import { useI18nContext } from '@/i18n/I18n';
const RetrieveEntryUI = ({ children }: { children: any }) => {
  const [$t] = useI18nContext();

  return (
    <div className="retrieve-container">
      <div className="cardContainer">
        <div data-paint className="title">
          {$t('Reset Password')}
        </div>
        {children}
      </div>
    </div>
  );
};

export default RetrieveEntryUI;
